module.exports = __webpack_public_path__ + "static/img/4.450b80e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/20/sp/4.png
// module id = RXOz
// module chunks = 0